import { isProperGeolocation } from '../services/get-geolocation';

// implement a code to extract the 'intentiq.com' value from our JSON.
const extractIiqId = (json) => {
  if (!json) {
    return null;
  }

  const eids = json.eids || [];

  let intentIqUids = null;

  for (const eid of eids) {
    if (eid.source === `intentiq.com`) {
      intentIqUids = eid.uids;
    }
  }

  if (intentIqUids) {
    for (const uid of intentIqUids) {
      if (uid.ext.stype === `ppuid`) {
        return uid.id;
      }
    }
  }

  return null; // Return null if no matching "id" value is found
};

const LOCATIONS = [`US`, `CA`, `JP`, `AU`, `SG`, `KR`, `TH`, `MY`, `NZ`, `MX`, `PH`];

const isIntentIqEnabled = (currentGeoLocation) =>
  FEATURES.INTENT_IQ && isProperGeolocation(currentGeoLocation, LOCATIONS);

export const initIntentIq = (geo, callback) => {
  window.IntentScriptOnLoad = () => {
    if (!isIntentIqEnabled(geo) || !window.IntentIqObject611) {
      callback && callback();
      return;
    }

    new window.IntentIqObject611({
      partner: 288563991,
      pbjs: window.pbjs,

      callback: (data, group) => {
        callback && callback(extractIiqId(data), { intent_iq_group: group || `N` });
      },
      timeoutInMillis: 500,
      ABTestingConfigurationSource: `IIQServer`,
      manualWinReportEnabled: false,
      vrBrowserBlackList: [`chrome`, `Firefox`, `Opera`, `AndroidWebkit`, `unknown`],
      domainName: window.Site.fullDomain,
    });
  };

  if (window.IntentScriptIsLoad) {
    window.IntentScriptOnLoad();
  }
};
